'use strict';

/**
 * Module definition for the base module
 *
 * @category   Module
 * @module     base
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Marionette = require('backbone-marionette');
var CollectionFieldsCollection = require('./collections/collection-fields');
var UnitsCollection = require('./collections/units');
var InputFieldsCollection = require('entities/InputFieldsCollection');

var BaseModule = Marionette.Module.extend({
    startWithParent: true,

    initialize: function(moduleName, app) {
        // Load collections on login
        this.listenTo(app.vent, 'logged-in', function() {
            app.loadData(this.inputFieldsCollection);
            app.loadData(this.collectionFieldsCollection);
            app.loadData(this.unitsCollection);
        }.bind(this));
    },

    onStart: function(options) {
        // User input fields
        this.inputFieldsCollection = new InputFieldsCollection();

        this.defaultInputFieldsCollection = this.inputFieldsCollection.getFilteredCollection(function(model) {
            return model.get('isEditField');
        });

        this.defaultTableColumnCollection = this.inputFieldsCollection.getFilteredCollection(function(model) {
            return model.get('isTableField');
        });

        this.printColumnCollection = this.inputFieldsCollection.getFilteredCollection(function(model) {
            return model.get('isPrintField');
        });

        // Init base collections
        this.collectionFieldsCollection = new CollectionFieldsCollection();

        // Init units collections
        this.unitsCollection = new UnitsCollection();

        this.sizeUnitsCollection = this.unitsCollection.getFilteredCollection(function(model) {
            return model.get('type') === 'size';
        });

        this.weightUnitsCollection = this.unitsCollection.getFilteredCollection(function(model) {
            return model.get('type') === 'weight';
        });
    },
});

module.exports = BaseModule;